<template>
  <header class="header" v-if="isPermissions">
    <div
      class="logo-header"
      :class="{ closed: isToggleSideBar }"
      v-if="isPermissions.support_payments || isPermissions.read_user_items"
    >
      <router-link to="./dashboard">
        <h1>SP Control</h1>
      </router-link>
      <div class="logo-header__burger" @click="toggleSideBar">
        <span></span>
      </div>
    </div>
    <nav class="nav">
      <div class="header__info" v-if="isPermissions.admin_payments">
        <div class="header__currency">
          <div class="header__currency__change" @click="showCurrencyMenu = !showCurrencyMenu">
            <span>{{ currencyMap[$store.state.currency] }}</span>
            <img
              :class="{ rotate: showCurrencyMenu }"
              src="../../assets/images/down-arrow.svg"
              alt="open"
            />
          </div>
          <div class="header__currency__menu" v-show="showCurrencyMenu">
            <p v-if="$store.state.currency !== 'usd'" @click="changeCurrency('usd')">
              <small>$</small>
            </p>
            <p v-if="$store.state.currency !== 'eur'" @click="changeCurrency('eur')">
              <small>€</small>
            </p>
            <p v-if="$store.state.currency !== 'rub'" @click="changeCurrency('rub')">
              <small>₽</small>
            </p>
          </div>
        </div>
        <span v-if="!isLoaded" class="balance"
          >Balance: {{ $store.state.balance }}{{ currencyMap[$store.state.currency] }}</span
        >
        <div class="lds-ring loader" v-if="isLoaded">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <button class="right-block" @click="exit">
        <img src="../../assets/images/exit.svg" alt="" />
      </button>
    </nav>
  </header>
</template>

<script>
import './header.scss'
import cookie from 'vue-cookie'

export default {
  name: 'Header',
  components: {},
  computed: {
    isToggleSideBar() {
      return this.$store.state.toggleSideBar
    },
    isPermissions() {
      return this.$store.state.permissions
    }
  },
  data() {
    return {
      currencyMap: {
        rub: '₽',
        usd: '$',
        eur: '€'
      },
      showCurrencyMenu: false,
      isLoaded: false
    }
  },
  watch: {
    isPermissions: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.changeCurrency('rub')
        }
      },
      immediate: true
    }
  },
  mounted() {
    // this.getAdminStatus();
  },
  // watch: {
  //     isPermissions: function () {
  //         if (this.isPermissions.admin_payments) {
  //             this.changeCurrency('rub')
  //         }
  //     }
  // },
  created() {
    this.initListeners()
  },
  destroyed() {
    this.initListeners()
  },
  methods: {
    exit() {
      cookie.delete('token')
      cookie.delete('refresh')
      this.$router.push('/')
    },
    toggleSideBar() {
      if (this.isToggleSideBar) {
        this.$store.dispatch('closeSideBar')
      } else {
        this.$store.dispatch('openSideBar')
      }
    },
    changeCurrency(currency) {
      if (
        (!this.isPermissions?.admin_payments || this.$store.state.balance) &&
        this.$store.state.currency === currency
      ) {
        return
      }
      this.showCurrencyMenu = false
      this.isLoaded = true
      fetch(
        `https://payments.neuralgeneration.com/api/v1/special/gm_balance?currency=${currency}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          const balance = data.balance
          this.$store.commit('setBalance', balance)
          this.$store.commit('setCurrency', currency)
          this.isLoaded = false
        })
    },
    closeByClickingOutSelectCurrency(event) {
      const path = event.path || (event.composedPath && event.composedPath())
      if (
        event &&
        !path.find((div) => div.classList && div.classList.contains('header__currency__change'))
      ) {
        this.showCurrencyMenu = false
      }
    },
    initListeners() {
      document.addEventListener('click', this.closeByClickingOutSelectCurrency)
    }
  }
}
</script>
